/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PayMateConnectorAssignmentDto } from "./PayMateConnectorAssignmentDto";
import {
    PayMateConnectorAssignmentDtoFromJSON,
    PayMateConnectorAssignmentDtoFromJSONTyped,
    PayMateConnectorAssignmentDtoToJSON,
} from "./PayMateConnectorAssignmentDto";

/**
 *
 * @export
 * @interface PayMateConnectorAssignmentsResponseDto
 */
export interface PayMateConnectorAssignmentsResponseDto {
    /**
     * The charger's linked PayMate device identity: the virtual parent if split across multiple terminals, or the single PayMate otherwise. Null if the charger has no linked PayMate at all.
     * @type {string}
     * @memberof PayMateConnectorAssignmentsResponseDto
     */
    payMateDeviceIdentity?: string;
    /**
     * Friendly name of the linked PayMate.
     * @type {string}
     * @memberof PayMateConnectorAssignmentsResponseDto
     */
    payMateFriendlyName?: string;
    /**
     * True if the linked PayMate has child PayMate terminals, meaning connectors are individually assigned via PayMateConnectorAssignment rows (some may be unsold). False if a single PayMate with no children sells every connector of this charger — the normal, non-split case.
     * @type {boolean}
     * @memberof PayMateConnectorAssignmentsResponseDto
     */
    hasChildPayMates?: boolean;
    /**
     * One entry per connector on the charger.
     * @type {Array<PayMateConnectorAssignmentDto>}
     * @memberof PayMateConnectorAssignmentsResponseDto
     */
    connectors?: Array<PayMateConnectorAssignmentDto>;
}

/**
 * Check if a given object implements the PayMateConnectorAssignmentsResponseDto interface.
 */
export function instanceOfPayMateConnectorAssignmentsResponseDto(
    value: object,
): value is PayMateConnectorAssignmentsResponseDto {
    return true;
}

export function PayMateConnectorAssignmentsResponseDtoFromJSON(
    json: any,
): PayMateConnectorAssignmentsResponseDto {
    return PayMateConnectorAssignmentsResponseDtoFromJSONTyped(json, false);
}

export function PayMateConnectorAssignmentsResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PayMateConnectorAssignmentsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        payMateDeviceIdentity:
            json["payMateDeviceIdentity"] == null
                ? undefined
                : json["payMateDeviceIdentity"],
        payMateFriendlyName:
            json["payMateFriendlyName"] == null
                ? undefined
                : json["payMateFriendlyName"],
        hasChildPayMates:
            json["hasChildPayMates"] == null
                ? undefined
                : json["hasChildPayMates"],
        connectors:
            json["connectors"] == null
                ? undefined
                : (json["connectors"] as Array<any>).map(
                      PayMateConnectorAssignmentDtoFromJSON,
                  ),
    };
}

export function PayMateConnectorAssignmentsResponseDtoToJSON(
    value?: PayMateConnectorAssignmentsResponseDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        payMateDeviceIdentity: value["payMateDeviceIdentity"],
        payMateFriendlyName: value["payMateFriendlyName"],
        hasChildPayMates: value["hasChildPayMates"],
        connectors:
            value["connectors"] == null
                ? undefined
                : (value["connectors"] as Array<any>).map(
                      PayMateConnectorAssignmentDtoToJSON,
                  ),
    };
}
